module.exports = __webpack_public_path__ + "img/confirmed-icn.c9700d1c.svg";